"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionDeriveResponseToJSON = exports.RosettaConstructionDeriveResponseFromJSONTyped = exports.RosettaConstructionDeriveResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaConstructionDeriveResponseFromJSON(json) {
    return RosettaConstructionDeriveResponseFromJSONTyped(json, false);
}
exports.RosettaConstructionDeriveResponseFromJSON = RosettaConstructionDeriveResponseFromJSON;
function RosettaConstructionDeriveResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': !runtime_1.exists(json, 'address') ? undefined : json['address'],
        'account_identifier': !runtime_1.exists(json, 'account_identifier') ? undefined : _1.RosettaAccountIdentifierFromJSON(json['account_identifier']),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaConstructionDeriveResponseFromJSONTyped = RosettaConstructionDeriveResponseFromJSONTyped;
function RosettaConstructionDeriveResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': value.address,
        'account_identifier': _1.RosettaAccountIdentifierToJSON(value.account_identifier),
        'metadata': value.metadata,
    };
}
exports.RosettaConstructionDeriveResponseToJSON = RosettaConstructionDeriveResponseToJSON;
//# sourceMappingURL=RosettaConstructionDeriveResponse.js.map